/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Fact_Offers_In_FeedInputs */

const cs_ebr_fact_offers_in_feed = /** @type {(inputs: Ebr_Fact_Offers_In_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky ve feedu`)
};

const en_ebr_fact_offers_in_feed = /** @type {(inputs: Ebr_Fact_Offers_In_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers in feed`)
};

/**
* | output |
* | --- |
* | "Offers in feed" |
*
* @param {Ebr_Fact_Offers_In_FeedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_fact_offers_in_feed = /** @type {((inputs?: Ebr_Fact_Offers_In_FeedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Fact_Offers_In_FeedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_fact_offers_in_feed(inputs)
	return cs_ebr_fact_offers_in_feed(inputs)
});